jPar.loginAndRegistration.loginPage = jPar.loginAndRegistration.loginPage || {};
deepMerge(true, jPar.loginAndRegistration.loginPage, {
	socialSignOn: {
		init: function () {
			const hasAppleSocialButton = document.querySelector('peg-apple-social-button') !== null;
			const hasGoogleSocialButton = document.querySelector('peg-google-social-button') !== null;

			if (hasAppleSocialButton) {
				this.apple.checkAutosubmit();
			}

			if (hasGoogleSocialButton) {
				this.google.init();
			}
		},

		google: {
			init: function init() {
				this.error.showGoogleBackendErrorModal();
				this.error.showErrorNoEMailAdressModal();
				this.checkAutosubmit();
			},

			checkAutosubmit: function () {
				const isFromGoogle = jPar.util.getGetParamFromUrl('scope') !== undefined;
				const hasNoError = jPar.util.getGetParamFromUrl('error') === undefined;
				const hasCode = jPar.util.getGetParamFromUrl('code') !== undefined;

				if (isFromGoogle && hasNoError && hasCode) {
					const form = document.querySelector('#loginForm');
					this.addHiddenInputfields(form);
					form.submit();
				}
			},

			addHiddenInputfields: function (form) {
				const socialProviderInput = document.createElement('input');
				socialProviderInput.type = 'hidden';
				socialProviderInput.name = 'socialProvider';
				socialProviderInput.value = 'GOOGLE';

				const socialAccessTokenInput = document.createElement('input');
				socialAccessTokenInput.type = 'hidden';
				socialAccessTokenInput.name = 'socialAccessToken';
				socialAccessTokenInput.value = jPar.util.getGetParamFromUrl('code');

				form.appendChild(socialProviderInput);
				form.appendChild(socialAccessTokenInput);
			},

			error: {
				showGoogleBackendErrorModal: function showGoogleBackendErrorModal() {
					if (document.querySelector('#googleBackendErrorModal') !== null) {
						jPar.wdk.modalbox.show({ modalboxId: 'googleBackendErrorModal' });
					}
				},

				showErrorNoEMailAdressModal: function () {
					if (document.querySelector('#googleNoEMailAdress') !== null) {
						jPar.wdk.modalbox.show({ modalboxId: 'googleNoEMailAdress' });
					}
				},
			},
		},

		apple: {
			checkAutosubmit: function () {
				// Return URL: /appleCallback?socialProvider=APPLE&id_token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6I&code=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6I&user=
				const isReturnFromApple = jPar.util.getGetParamFromUrl('socialProvider') === 'APPLE';
				const hasNoError = jPar.util.getGetParamFromUrl('error') === undefined;

				this.error.showAppleBackendErrorModal();

				if (isReturnFromApple && hasNoError) {
					this.localFormPreparation();
					jPar.loginAndRegistration.util.showLoadingAnimation();
					document.querySelector('#loginForm').submit();
				}
			},

			localFormPreparation: function () {
				const appleButton = document.querySelector('peg-apple-social-button');
				const idToken =
					appleButton && appleButton.getAttribute('social-provider-token') !== null
						? appleButton.getAttribute('social-provider-token')
						: jPar.wdk.security.escapeStringForHtml(jPar.util.getGetParamFromUrl('id_token')); // <- deprecated by MOVE_TOKEN_PARAMETER_FROM_APPLE_LOGIN_BY_MANTIS - set empty string if appleButton.getAttribute('social-provider-token') = null
				const code = jPar.wdk.security.escapeStringForHtml(jPar.util.getGetParamFromUrl('code')); // Apple Information
				const user = jPar.util.getGetParamFromUrl('user'); // don't sanitize, because the param 'user' is a json, see: https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js/incorporating_sign_in_with_apple_into_other_platforms

				const template = document.createElement('template');
				const filledHiddenInputs = `
					<div>
						<input type="hidden" name="socialProvider" value="APPLE">
						<input type="hidden" name="id_token" value="${idToken}">
						<input type="hidden" name="code" value="${code}">
						<input type="hidden" name="user" value="${user}">
					</div>
				`;
				template.innerHTML = jPar.wdk.security.sanitizeEvilHtml(filledHiddenInputs);
				const node = template.content.firstElementChild;
				document.querySelector('#loginForm').appendChild(node);
			},

			error: {
				showAppleBackendErrorModal: function showAppleBackendErrorModal() {
					if (document.querySelector('#appleBackendErrorModal') !== null) {
						jPar.wdk.modalbox.show({ modalboxId: 'appleBackendErrorModal' });
					}
				},
			},
		},
	},
});
